import { FormsService } from "./../../../services/forms";
import { getChangedFormNativeSettings } from "../../../helpers/dataManipulations";
import { ChangeNativeFormSettingsRequestActionType } from "../types";

export function* updateNativeSettingsSaga({ payload }: ChangeNativeFormSettingsRequestActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedFormNativeSettings(payload.prevState, payload.currentState),
        });
    } catch (error) {
        console.log("Error ", error);

        // yield(Handle Error)
    }
}
